export interface WordpressPost {
    date: string,
    title: string,
    yoast_head_json: {
        title: string
        description: string
    },
    slug: string
    excerpt: string
    featured_media: {
        source_url: string
    } | null;
    author: {
        name: string
    }
    categories: {
        name: string
        slug: string
    }[]
}

export function trimString(str: string, length: number) {
    if (str.length > length){
        str = str.substr(0,length);
        return str.substr(0,Math.min(str.length,str.lastIndexOf(" "))) + ' [...]'
    } else{
        return str;
    }
}